import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import NoteCard from '../components/NoteCard';
import FilterBar from '../components/FilterBar';
import EmptyState from '../components/EmptyState';
import LoadingSkeleton from '../components/LoadingSkeleton';
import UploadModal from '../components/UploadModal';
import api from '../services/api';
import { FiPlus, FiBook } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const Notes = ({ onLogout }) => {
  const navigate = useNavigate();
  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData) : null;
  const canUploadDirectly = user?.role === 'teacher' || user?.role === 'admin';

  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [filters, setFilters] = useState({
    search: '',
    department: '',
    semester: '',
    subject: '',
    type: '',
    year: '',
    examType: ''
  });

  const departments = ['Computer Science', 'Electronics', 'Mechanical', 'Civil', 'Electrical'];
  const semesters = [1, 2, 3, 4, 5, 6, 7, 8];
  const examTypes = ['midsem', 'endsem', 'quiz', 'other'];

  const fetchNotes = React.useCallback(async () => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });

      const response = await api.get(`/notes?${queryParams}`);
      setNotes(response);
    } catch (error) {
      console.error('Error fetching notes:', error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchNotes();
  }, [fetchNotes]);

  const handleFilterChange = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="dashboard-container">
      <Sidebar onLogout={onLogout} />

      <div className="main-content">
        <Header
          title="Notes Library"
          subtitle="Browse, search, and download study materials contributed by faculty and peers."
        />

        <FilterBar
          filters={filters}
          onFilterChange={handleFilterChange}
          departments={departments}
          semesters={semesters}
          examTypes={examTypes}
        />

        <div className="d-flex justify-between align-center mb-4">
          <h2 style={{ fontSize: '18px', fontWeight: '600' }}>Study Materials ({notes.length})</h2>

          <button
            className="btn btn-primary"
            onClick={() => {
              if (canUploadDirectly) {
                setShowUploadModal(true);
              } else {
                navigate('/upload');
              }
            }}
          >
            <FiPlus /> {canUploadDirectly ? 'Upload Note' : 'Submit Note Request'}
          </button>
        </div>

        {loading ? (
          <LoadingSkeleton type="card" count={6} />
        ) : notes.length > 0 ? (
          <div className="notes-grid">
            {notes.map((note) => (
              <NoteCard key={note._id} note={note} onDeleteSuccess={fetchNotes} />
            ))}
          </div>
        ) : (
          <EmptyState
            icon={<FiBook />}
            title="No study materials found"
            description="Try adjusting your filter settings or upload a new resource to the library."
            actionButton={
              <button
                className="btn btn-secondary"
                onClick={() => handleFilterChange('search', '')}
              >
                Clear Search & Filters
              </button>
            }
          />
        )}
      </div>

      {showUploadModal && (
        <UploadModal onClose={() => setShowUploadModal(false)} onSuccess={fetchNotes} />
      )}
    </div>
  );
};

export default Notes;